import { render, staticRenderFns } from "./UserReferrals.vue?vue&type=template&id=62dd82b3&scoped=true"
import script from "./UserReferrals.vue?vue&type=script&lang=js"
export * from "./UserReferrals.vue?vue&type=script&lang=js"
import style0 from "./UserReferrals.vue?vue&type=style&index=0&id=62dd82b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dd82b3",
  null
  
)

export default component.exports